import { render, staticRenderFns } from "./CampaignSetup.vue?vue&type=template&id=c5e0b28a&scoped=true&"
import script from "./CampaignSetup.vue?vue&type=script&lang=js&"
export * from "./CampaignSetup.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetup.vue?vue&type=style&index=0&id=c5e0b28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e0b28a",
  null
  
)

export default component.exports